module.exports = __webpack_public_path__ + "static/media/logo.4ee5092c.png";